import classNames from 'classnames';
import { FC } from 'react';

export interface IProgressBarProps {
  className?: string;
  percent: number;

  size?: 'small' | 'medium' | 'large';
}

export const ProgressBar: FC<IProgressBarProps> = props => (
  <div
    className={classNames('progress', {
      'progress-sm': props.size === undefined || props.size === 'small',
      'progress-md': props.size === 'medium',
      'progress-lg': props.size === 'large',
    })}
  >
    <div className={`progress-bar ${props.className}`} style={{ width: `${props.percent}%` }} />
  </div>
);
